import { ROLES } from '@/constants/roles';

export default [
  {
    path: '/user-autocompletes',
    name: 'user-autocompletes',
    component: () => import('./views/user-autocompletes.vue'),
    meta: {
      title: 'Настройка информации',
      layout: 'ui-design',
      roles: [ROLES.member, ROLES.certificate],
    },
  },
];
